<template>
  <div class="login-page">
    <div class="login">
      <img :src="logo" class="logo" alt="">
      <el-form :model="userInfo" size="small" :rules="validateRules" label-width="65px" @keyup.enter.native="login">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userInfo.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="userInfo.password" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" :loading="loading" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="company">中旅策科技（北京）有限公司 版权所有 &copy;2019-2026 All Rights Reserved</div>
    </div>
  </div>
</template>

<script>
  import logo from "@/assets/images/logo.png"

  export default {
    name: "login",
    data() {
      return {
        logo: logo,
        loading: false,
        userInfo: {
          username: '',
          password: '',
        },
        validateRules: {
          username: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ]
        }
      }
    },
    methods: {
      login: function () {
        this.loading = true;
        this.$http.request('adminLogin', this.userInfo).then(res => {
          this.loading = false;
          if (res.status === 'success') {
            localStorage.setItem('user', JSON.stringify(res.data));
            let url = this.$route.query.url;
            if(url){
              this.$router.push({path:url});
            }else{
              this.$router.push({name:'index'});
            }
          }
        });
      }
    }
  }
</script>

<style scoped lang="less">
  .login-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding-top: 100px;
    background: url('https://migumao-static.oss-cn-beijing.aliyuncs.com/gulangyu-piaowu/images/login-bg.png') no-repeat center center;
    background-size: cover;
  }

  .login {
    width: 500px;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 10px 20px;
    margin: 0 auto;
    background: #fff;
  }

  .login .logo {
    height: 48px;
    width: auto;
    max-width: 280px;
    display: block;
    margin: auto;
    margin-bottom: 20px;
    object-fit: contain;
  }

  .company {
    text-align: center;
    font-size: 12px;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue